export default __webpack_public_path__ + "static/media/fleetview.b5c3247d.jpg";